import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import styles from "./StatePage.module.css";

interface StatePageProps {
  /** El `h1` de la pantalla: la frase que dice qué pasa. */
  title: string;
  body?: string;
  action?: { to: string; label: string };
  children?: ReactNode;
}

/** Pantalla completa de estado (sin permiso, no encontrada): un `h1`, una explicación y una salida. */
export function StatePage({ title, body, action, children }: StatePageProps) {
  return (
    <div className={styles.wrap}>
      <svg className={styles.icon} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <path d="M8 12h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
      <h1 className={styles.title} tabIndex={-1}>{title}</h1>
      {body ? <p className={styles.body}>{body}</p> : null}
      {action ? <div className={styles.action}><Link className={styles.link} to={action.to}>{action.label}</Link></div> : null}
      {children ? <div className={styles.extra}>{children}</div> : null}
    </div>
  );
}
